import { OnDestroy, OnInit } from '@angular/core';
import { FiHighlightService } from '@fi-shared/fi-highlight/fi-highlight.service';
import { Component, ViewEncapsulation } from '@angular/core';
import { FiDocumentLayoutItemTextBase } from '../layout-item-text-base';
import { TextEditorHistoryService } from '@fi-shared/fi-text-editor/fi-text-editor-helper-services/text-editor-history.service';
import { AdvancedTextHandlerService } from '@fi-shared/fi-text-editor/fi-text-editor-helper-services/advanced-text-handler.service';
import { TemplateLayoutLanguageService } from '@fi-app/template/template-layout-language.service';
import { ITemplatePlaceHolderControlContent } from '@fi-app/template/template';
import { TextEditorSelectionElementBuilderService } from '@fi-shared/fi-text-editor/fi-text-editor-helper-services/text-editor-selection-element-builder.service';
import { FiTextPanelType } from '@fi-shared/fi-text-panel/fi-text-panel-type';

@Component({
    selector: 'fi-document-layout-item-advanced-text',
    templateUrl: './layout-item-advanced-text.component.html',
    encapsulation: ViewEncapsulation.None,
    styleUrls: ['./layout-item-advanced-text.component.scss'],
    host: { class: 'fi-document-layout-item-advanced-text' },
    standalone: false,
})
export class FiDocumentLayoutItemAdvancedTextComponent
    extends FiDocumentLayoutItemTextBase
    implements OnInit, OnDestroy
{
    constructor(
        private textEditorHistoryService: TextEditorHistoryService,
        private advancedTextHandlerService: AdvancedTextHandlerService,
        templateLayoutLanguageService: TemplateLayoutLanguageService,
        textEditorSelectionElementBuilderService: TextEditorSelectionElementBuilderService,
        private highlightService: FiHighlightService,
    ) {
        super(textEditorSelectionElementBuilderService, templateLayoutLanguageService);
    }

    initialText: string;

    ngOnInit() {
        super.ngOnInit();
    }

    // todo: fix history for 2 columns
    editorInit($event: Element) {
        this.initialText = $event.innerHTML;
    }

    getContent(contentTextValue: string) {
        return this.highlightService.getHighlightLayout(contentTextValue);
    }

    textChange($event, content: ITemplatePlaceHolderControlContent) {
        this.contentChange.emit($event);
        content.modified = true;
    }

    ngOnDestroy() {
        this.highlightService.setHighlightText(undefined);
    }

    protected readonly FiTextPanelType = FiTextPanelType;
}
